import script from "./ServicesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServicesSection.vue?vue&type=script&setup=true&lang=ts"

import "./ServicesSection.vue?vue&type=style&index=0&id=4da23725&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4da23725"]])

export default __exports__